/*global
    jQuery
*/
(function ($) {
    var $searchButton = $('button.shelter_rescue_search_submit');
    var $submitButton = $('button.shelter_rescue_select_button');
    var $popupTrigger = $('a.shelter_rescue_search_trigger');

    var showShelterRescueSearch = function(e) {
        e.preventDefault();
        $('div#shelter_rescue_search_form').removeClass('closed');
        var previousSearchLocation = $('input[name="shelter_zip"]').val();
        if (previousSearchLocation.length > 0) {
            $('input.shelter_rescue_search_input').val(previousSearchLocation);
            $searchButton.click();
        }
        return false;
    }

    $popupTrigger.on('click', showShelterRescueSearch);

    var maxShow = 20;
    var getMaxShow = function() {
        if ($('div.shelter_rescue_is_mobile').length > 0 && $('div.shelter_rescue_is_mobile').is(':visible')) {
            maxShow = 6;
        } else {
            maxShow = 20;
        }
    }
    getMaxShow();

    var shelterSelected = function() {
        var $selected = $('div.shelter_rescue_results').find('input:checked');
        if ( $selected.length == 0 ) {
            return true;
        }
        var shelterId = $selected.val();
        var shelterLocation = $('input.shelter_rescue_search_input').val();
        var shelterName = $selected.siblings('span.shelter_rescue_shelter_name').text();

        // Populate form fields with values from selection
        $('input[name="shelter_zip"]').val(shelterLocation);
        $('input[name="donation_shelter_rescue"]').val(shelterId);
        $('input[name="dummy_shelter"]').val(shelterName);
        $('div#shelter_rescue_search_form').addClass('closed');
        $('input[name="dummy_shelter"]').blur(); // trigger ajax save
    }

    $submitButton.on('click', shelterSelected);

    var initPagination = function() {
        var $resultsWrapper = $('div.shelter_rescue_results');
        // Hide all but the first 20 results
        var $allResults = $resultsWrapper.find('div.shelter_rescue_single');
        getMaxShow();
        for(var i = 0; i < maxShow; i++) {
            if ( typeof $allResults[i] !== 'undefined' ) {
                $($allResults[i]).show();
            }
        }

        var $shownResults = $resultsWrapper.find('div.shelter_rescue_single:visible');
        var totalPages = Math.ceil($allResults.length / maxShow);
        var paginationDetails = '<div class="shelter_rescue_page_buttons"><button class="shelter_rescue_pagination_back"><</button> Page <span class="shelter_rescue_current_page">1</span> of <span class="shelter_rescue_total_pages">' + totalPages + '</span> <button class="shelter_rescue_pagination_next">></button></div>';

        $('div.shelter_rescue_pagination').html(paginationDetails);
        $('div.shelter_rescue_pagination_bottom').html(paginationDetails);
        $('button.shelter_rescue_pagination_back').on('click', prevPage);
        $('button.shelter_rescue_pagination_next').on('click', nextPage);
        updatePaginationDetails('1', $shownResults.length, $allResults.length - 1);
    }

    var updatePaginationDetails = function(start, end, total) {
        if ( end > total ) {
            end = total;
        }
        $('div.shelter_rescue_pagination_details_mobile').text(start + ' - ' + end + ' of ' + total + ' Shelters & Rescues Near You');
    }

    var nextPage = function() {
        var $resultsWrapper = $('div.shelter_rescue_results');
        var $allResults = $resultsWrapper.find('div.shelter_rescue_single');
        var currentPage = parseInt($('span.shelter_rescue_current_page:first').text());
        var totalPages = parseInt($('span.shelter_rescue_total_pages:first').text());
        var startNumber = (currentPage * maxShow) + 1;
        var nextPage = currentPage + 1;
        var endNumber = maxShow * nextPage;
        console.log('NEXT -- Start number: ' + startNumber + ', end number: ' + endNumber + ', currentPage: ' + currentPage + ', nextPage: ' + nextPage + ', totalPages: ' + totalPages);
        console.log('allResults count: ' + $allResults.length);
        if ( nextPage > totalPages ) {
            return true;
        }
        $allResults.hide();
        updatePaginationDetails(startNumber, endNumber, $allResults.length - 1);
        for(startNumber - 1; startNumber <= endNumber; startNumber++) {
            $($allResults[startNumber]).show();
        }
        $('span.shelter_rescue_current_page').each(function() {
            $(this).text(nextPage);
        });
    }

    var prevPage = function() {
        var $resultsWrapper = $('div.shelter_rescue_results');
        var $allResults = $resultsWrapper.find('div.shelter_rescue_single');
        var currentPage = parseInt($('span.shelter_rescue_current_page:first').text());
        var totalPages = parseInt($('span.shelter_rescue_total_pages:first').text());
        var prevPage = currentPage - 1;
        var startNumber;
        if ( prevPage === 1 ) {
            startNumber = 1;
        } else {
            startNumber = ((prevPage - 1) * maxShow) + 1;
        }
        var endNumber = (startNumber + maxShow) - 1;
        console.log('PREV -- Start number: ' + startNumber + ', end number: ' + endNumber + ', currentPage: ' + currentPage + ', prevPage: ' + prevPage + ', totalPages: ' + totalPages);
        console.log('allResults count: ' + $allResults.length);
        if ( prevPage < 1 ) {
            return true;
        }
        $allResults.hide();
        updatePaginationDetails(startNumber, endNumber, $allResults.length - 1);
        for(startNumber - 1; startNumber <= endNumber; startNumber++) {
            $($allResults[startNumber]).show();
        }
        $('span.shelter_rescue_current_page').each(function() {
            $(this).text(prevPage);
        });
    }

    var filterList = function(filterOn) {
        if ( filterOn !== 'all' ) {
            $.when(removeFilter()).then(function() {
                var $resultsWrapper = $('div.shelter_rescue_results');
                var $allResults = $resultsWrapper.find('div.shelter_rescue_single');
                var regexFilter = new RegExp('^['+filterOn+']', 'i');
                $allResults.each(function() {
                    if(regexFilter.test($(this).text())) {
                    } else {
                        $(this).remove();
                    }
                }).promise().done(initPagination);
            });
        } else {
            removeFilter();
        }
    }

    var removeFilter = function() {
        var $originalResults = $('.shelter_rescue_unfiltered_data');
        var $resultsWrapper = $('div.shelter_rescue_results');
        $resultsWrapper.html($originalResults.html());
        initPagination();
    }

    $('button.alpha_filter_button').on('click', function(e) {
        $('div.alpha-filters').find('button.selected-filter').removeClass('selected-filter');
        $(this).addClass('selected-filter');
        filterList($(this).data('filter-var'));
    });

    $('div.alpha-filters-mobile').find('select[name="alpha_filter_select"]').on('change', function(e) {
        var selectedOption = $("option:selected", this);
        console.log('Selected option: ' + selectedOption.val());
        filterList(selectedOption.val());
    });

    $searchButton.on('click', function(e) {
        var searchParam = $('input[name="shelter_rescue_search_input"]').val();
        // determine if zipcode was provided
        var matches = searchParam.match(/\d+/g);
        var url = '/api/shelter/';
        var zipcode;
        if (matches !== null && matches[0].length >= 5) {
            zipcode = matches[0];
            url = url + zipcode;
        } else {
            matches = searchParam.match(/\D+/g);
            if ( matches !== null ) {
                var cityState = matches[0].trim();
                cityState = cityState.split(',');
                if ( cityState !== null && cityState.length == 2) {
                    var city = cityState[0].trim();
                    var state = cityState[1].trim();
                    url = url + city + '/' + state;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'json',
            headers:{
                'X-CSRF-TOKEN': $('#shelter_rescue_selection').find('input[name="_token"]').val()
            }
        }).done(function(response, status) {
            $('div.shelter_rescue_total_shelters').find('span#total_shelters').text(response.shelters.length - 1);
            $('div.shelter_rescue_total_shelters').show();
            var $resultsWrapper = $('div.shelter_rescue_results');
            var newResults = '';
            var originalResults = '<div class="shelter_rescue_unfiltered_data" style="display:none;"></div>';
            if ( $('.shelter_rescue_unfiltered_data').length === 0 ) {
                $('body').append(originalResults);
            }
            var $originalResults = $('.shelter_rescue_unfiltered_data');
            $.each(response.shelters, function(i, v) {
                if ( typeof v !== 'undefined' && typeof v.shelter_name !== 'undefined' && typeof v.shelter_id !== 'undefined' ) {
                    newResults += '<div class="shelter_rescue_single" style="display:none;"><input type="radio" name="shelter_rescue_selection" value="' + v.shelter_id + '"><span class="shelter_rescue_shelter_name">' + v.shelter_name + '</span><span class="shelter_rescue_shelter_city">'+ v.shelter_city_state + '</span></div>';
                }
            });
            $resultsWrapper.html(newResults);
            $originalResults.html(newResults);
            initPagination();
        });

    });

}(jQuery));
